export default __webpack_public_path__ + "static/media/banner-happy-new-year-l.01840be9.png";